if (window.location.href.includes("reservas")) {

    // Configuración de las opciones de la solicitud
    const requestOptions = {
        method: "GET",
        credentials: "include", // Incluye las cookies automáticamente
        headers: {
            "Content-Type": "application/json", // Si es necesario especificar un tipo de contenido
        },
        redirect: "follow",
    };

    const tableBody = document.querySelector("#MisReservas tbody");

    // Función para actualizar la tabla según los filtros
    function actualizarTabla(signal, { esRefrescoSilencioso = false } = {}) {

        const filtroBuscar = document.getElementById("filtroBuscar").value;
        const filtroImpo = document.getElementById("filtroImpo").value;
        const filtroEstado = document.getElementById("filtroEstado").value;

        if (!esRefrescoSilencioso) {
            window.mostrarFilasEsqueleto(tableBody, 10);
        }

        const params = new URLSearchParams({
            filtroBuscar,
            filtroImpo,
            filtroEstado,
        });
        const url = `/api/reservas?${params.toString()}`;

        return fetch(url, { ...requestOptions, cache: "no-store", signal, sinCargando: true })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {
                // Limpiar la tabla antes de llenarla nuevamente
                
                tableBody.innerHTML = "";
                
                const jsonData = result;
                const imp = jsonData.result;

                imp.resultado.forEach(item => {
                    const row = document.createElement("tr");
                    row.innerHTML = `
                        <td class="td-periodo">
                            <a class="a-table" href="/detalle-importacion?id-impo=${item.id_impo}">
                                ${item.nombre_impo}
                            </a>
                        </td>
                        <td># ${item.id_reserva}</td>
                        <td>${item.pedido_sap ?? "—"}</td>
                        <td>${item.codigo}</td>
                        <td class="td-d">${item.descripcion}</td>
                        <td class="td-num">${Number(item.solicitud_reserva).toLocaleString()}</td>
                        <td class="td-num">${Number(item.reserva_autorizada).toLocaleString()}</td>
                        <td>${item.fecha_creacion}</td>
                        <td><div class="td-${item.id_estado}"><p class="p-color">${item.estado}</p></div></td>
                        <td>
                            <div class="cont-acciones">
                                <button class="btn-tabla btn-editarReserva" type="button" data-id="${item.id_reserva}" title="Ver reserva" aria-label="Ver reserva ${item.codigo ?? ''}">
                                    <img class="svg-acciones " src="/public/build/img/icons/ojo.svg" alt="">
                                </button>
                            </div>
                        </td>
                    `;
                    tableBody.appendChild(row);
                });
                
                if(imp.num_registros === 0){
                    const row = document.createElement("tr");
                    row.classList.add("no-data"); // Asignar la clase al <tr>
                    row.innerHTML = `
                                <td colspan="10">
                                    <div class="cont-no-data">
                                        No se encontró información.
                                        <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                                    </div>
                                </td>
                    `;
                    tableBody.appendChild(row);
                }
            });
    }

    const actualizador = window.crearActualizadorApi(actualizarTabla);

    // Esperar una pausa corta antes de consultar con los nuevos filtros.
    document.getElementById("filtroBuscar").addEventListener("input", actualizador.alCambiarFiltro);
    document.getElementById("filtroImpo").addEventListener("input", actualizador.alCambiarFiltro);
    document.getElementById("filtroEstado").addEventListener("change", actualizador.alCambiarFiltro);

    // Limpiar filtros
    const btnLimpiarFiltros = document.getElementById("btnLimpiarFiltros");
    if (btnLimpiarFiltros) {
        btnLimpiarFiltros.addEventListener("click", () => {
            document.getElementById("filtroBuscar").value = "";
            document.getElementById("filtroImpo").value = "";
            document.getElementById("filtroEstado").value = "0";
            actualizador.alCambiarFiltro();
        });
    }

    // Carga inicial inmediata y siguientes actualizaciones cada 5 minutos.
    actualizador.iniciar();
}
